import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ProjectionGridPanel } from './projections-mobileview/ProjectionGridPanel';
import { Swipeable } from 'react-touch';
import NumberUtils from '../../../utils/NumberUtils';
import ProjectionDateUtils from '../../../utils/ProjectionDateUtils';
import { ProjectionDetailsPage } from './ProjectionDetailsPage';
import InternetBankingActions from '../../../actions/InternetBankingActions';
import BrowserUtils from '../../../utils/BrowserUtils';
import { SettingsMainPage } from './SettingsMainPage';
import SvgIcon from '../../common/SvgIcon';

let earningsHeader = 'The next cash coming into your account should be';
let _isMounted = false;

const getStateFromStores = () => {
  return {
    wheelDegree: 0,
  };
};

/**
 * @todo
 * The quality of this component is very poor.
 * Future improvement work should be undertaken to refactor and increase
 * the quality of the component to improve the health of the codebase.
 */
class ProjectionScreen extends Component {
  constructor(props) {
    super(props);

    this.onStoreChange = this.onStoreChange.bind(this);
    this.projectionWheelLeftMove = this.projectionWheelLeftMove.bind(this);
    this.projectionWheelRightMove = this.projectionWheelRightMove.bind(this);
    this.projectionWheelLeftClick = this.projectionWheelLeftClick.bind(this);
    this.projectionWheelRightClick = this.projectionWheelRightClick.bind(this);
    this.nextEarningProjectionPeriod =
      this.nextEarningProjectionPeriod.bind(this);
    this._getProjectionSummaryContent =
      this._getProjectionSummaryContent.bind(this);
    this._getCurrentBalanceContent = this._getCurrentBalanceContent.bind(this);
    this._getCommitmentContent = this._getCommitmentContent.bind(this);
    this._getEssentialSpendContent = this._getEssentialSpendContent.bind(this);
    this._getNextEarningContent = this._getNextEarningContent.bind(this);
    this.doneClick = this.doneClick.bind(this);
    this.backToTop = this.backToTop.bind(this);
    this.getSettings = this.getSettings.bind(this);
    this.getWheelToSweep = this.getWheelToSweep.bind(this);
    this.getWebView = this.getWebView.bind(this);

    this.state = getStateFromStores();
  }

  componentWillMount() {
    BrowserUtils.setViewPort(1);
  }

  componentDidMount() {
    _isMounted = true;
  }

  componentWillUnmount() {
    _isMounted = false;
  }

  onStoreChange() {
    this.setState(getStateFromStores());
  }

  // method defined to move the wheel component left side.
  projectionWheelLeftMove() {
    if (_isMounted) {
      this.setState({ wheelDegree: this.state.wheelDegree + 72 });
    }
  }

  // method defined to move the wheel component right side.
  projectionWheelRightMove() {
    if (_isMounted) {
      this.setState({ wheelDegree: this.state.wheelDegree - 72 });
    }
  }

  // method defined to move the wheel component left click.
  projectionWheelLeftClick() {
    if (_isMounted) {
      this.setState({ wheelDegree: this.state.wheelDegree + 72 });
    }
  }

  // method defined to move the wheel component right side.
  projectionWheelRightClick() {
    if (_isMounted) {
      this.setState({ wheelDegree: this.state.wheelDegree - 72 });
    }
  }

  // methods for nextEarningProjectionPeriod()
  nextEarningProjectionPeriod() {
    if (this.props.projectionSummary !== undefined) {
      let i;
      for (
        i = 1;
        i <= this.props.projectionSummary.projection_periods.length;
        i++
      ) {
        if (this.props.projectionSummary.projection_periods[i] !== undefined) {
          if (
            this.props.projectionSummary.projection_periods[i].earnings !==
            undefined
          ) {
            if (
              this.props.projectionSummary.projection_periods[i].earnings
                .length > 0
            ) {
              return true;
            } else {
              return false;
            }
          }
        }
      }
      return false;
    }
  }

  // method to display projection summary of the wheel
  _getProjectionSummaryContent() {
    let message;
    if (!BrowserUtils.isMobileView()) {
      if (
        this.props.projectionSummary.projection_periods[0].warning_days === 0
      ) {
        message =
          this.props.content.projectionsExpandedItemViewSpinTheWheelFootNote;
      } else {
        message = this.props.content.projectionSpinWheelText;
      }
    } else {
      message = '';
    }
    let currentAmount;
    let overAllAmount;
    let essentialAmount;
    let currentBalance;
    let essentialSpendAmount;
    let commitmentsAmount;
    let amount;
    let lowBalanceAmount;
    let lAmount;
    let tomorrowsEarnings;
    let tEarnings;
    let tLength;
    let projectionMiddleContent;
    if (this.props.projectionSummary !== undefined) {
      if (
        this.props.projectionSummary.projection_periods[0].hasOwnProperty(
          'warning_days'
        )
      ) {
        const warningDays =
          this.props.projectionSummary.projection_periods[0].warning_days;
        if (warningDays.length === 0) {
          projectionMiddleContent =
            this.props.content
              .projectionsExpandedItemViewThisIsMadeUpOfSubHeading;
          currentAmount =
            this.props.projectionSummary.projection_periods[0].period.from
              .available_balance.value;
          currentBalance = (
            <li>
              <span className="value">
                {NumberUtils.appendCurrency('{}', currentAmount)}
              </span>
              <span className="value-tag">
                {this.props.content.projectionsExpandedItemViewCurrentBalance}
              </span>
            </li>
          );
          essentialAmount =
            this.props.projectionSummary.projection_periods[0]
              .essential_spend_info.total_amount.value;
          essentialSpendAmount = (
            <li>
              <span className="value">
                {NumberUtils.appendCurrency('{}', essentialAmount)}
              </span>
              <span className="value-tag">
                {this.props.content.projectionsExpandedItemViewEssentialSpend}
              </span>
            </li>
          );
          amount =
            this.props.projectionSummary.projection_periods[0]
              .projected_transactions.total_amount.value;
          commitmentsAmount = (
            <li>
              <span className="value">
                {NumberUtils.appendCurrency('{}', amount)}
              </span>
              <span className="value-tag">
                {this.props.content.projectionsExpandedItemViewCommitments}
              </span>
            </li>
          );
          lAmount = this.props.projectionSummary.thresholds.lower.amount.value;
          lowBalanceAmount = (
            <li>
              <span className="value">
                {NumberUtils.appendCurrency(
                  '{}',
                  this.props.projectionSummary.thresholds.lower.amount.value *
                    -1
                )}
              </span>
              <span className="value-tag">
                {this.props.content.projectionsExpandedItemViewLowBalanceLimit}
              </span>
            </li>
          );
          tLength =
            this.props.projectionSummary.projection_periods[0].earnings.length;
          tEarnings =
            tLength > 0 ? (
              <li>
                <span className="value">
                  {NumberUtils.appendCurrency(
                    '{}',
                    this.props.projectionSummary.projection_periods[0]
                      .earnings[0].amount.value
                  )}
                </span>
                <span className="value-tag">
                  {
                    this.props.content
                      .projectionsExpandedItemViewTomorrowsEarnings
                  }
                </span>
              </li>
            ) : (
              ''
            );
          if (
            this.props.projectionSummary.projection_periods[0].earnings.length >
            0
          ) {
            tomorrowsEarnings =
              this.props.projectionSummary.projection_periods[0].earnings[0]
                .amount.value;
          } else {
            tomorrowsEarnings = 0;
            if (!this.nextEarningProjectionPeriod()) {
              projectionMiddleContent =
                this.props.content
                  .projectionsExpandedItemViewThisIsMadeUpOfWthin31DaysSubHeading;
            } else {
              projectionMiddleContent =
                this.props.content
                  .projectionsExpandedItemViewThisIsMadeUpOfSubHeading;
            }
          }
          overAllAmount =
            currentAmount +
            essentialAmount +
            amount +
            tomorrowsEarnings +
            lAmount * -1;
          const amountArr = _.split(
            NumberUtils.appendCurrency('{}', overAllAmount),
            '.'
          );
          return (
            <div
              className="content-block"
              className={
                (this.state.wheelDegree === 0 ? 'active content-block' : '') ||
                (this.state.wheelDegree % 360 === 0
                  ? 'active content-block'
                  : '') ||
                (this.state.wheelDegree % -360 === 0
                  ? 'active content-block'
                  : '')
              }
            >
              <h3 className="wheel-stmnt">
                {this.props.content.projectionSummaryHeaderNoWarningDays}
              </h3>
              <h3 className="current-date">
                {amountArr[0]}.<sub>{amountArr[1]}</sub>
              </h3>
              <h3 className="wheel-stmnt2">{projectionMiddleContent}</h3>
              <ul className="balance-info">
                {currentBalance}
                {tEarnings}
                {commitmentsAmount}
                {essentialSpendAmount}
                {lowBalanceAmount}
              </ul>
              <h3 className="wheel-stmnt2">{message}</h3>
            </div>
          );
        } else if (warningDays.length > 0) {
          let amount = NumberUtils.appendCurrency(
            '{}',
            this.props.projectionSummary.thresholds.lower.amount.value
          );
          // projectionSummaryHeader = "Looks like you'll go below your low balance limit of" + ' ' + NumberUtils.appendCurrency('{}', this.props.projectionSummary.thresholds.lower.amount.value) + ' ' + 'on';
          let projectionSummaryHeader =
            this.props.content.projectionSummaryHeaderWarningDays.replace(
              '{amount}',
              amount
            );
          currentAmount =
            this.props.projectionSummary.projection_periods[0].period.from
              .available_balance.value;
          currentBalance = (
            <li>
              <span className="value">
                {NumberUtils.appendCurrency('{}', currentAmount)}
              </span>
              <span className="value-tag">Current Balance</span>
            </li>
          );
          essentialAmount =
            this.props.projectionSummary.projection_periods[0]
              .essential_spend_info.total_amount.value;
          essentialSpendAmount = (
            <li>
              <span className="value">
                {NumberUtils.appendCurrency('{}', essentialAmount)}
              </span>
              <span className="value-tag">Essential spend</span>
            </li>
          );
          amount =
            this.props.projectionSummary.projection_periods[0]
              .projected_transactions.total_amount.value;
          commitmentsAmount = (
            <li>
              <span className="value">
                {NumberUtils.appendCurrency('{}', amount)}
              </span>
              <span className="value-tag">Commitments</span>
            </li>
          );
          tLength =
            this.props.projectionSummary.projection_periods[0].earnings.length;
          tEarnings =
            tLength > 0 ? (
              <li>
                <span className="value">
                  {NumberUtils.appendCurrency(
                    '{}',
                    this.props.projectionSummary.projection_periods[0]
                      .earnings[0].amount.value
                  )}
                </span>
                <span className="value-tag">
                  {
                    this.props.content
                      .projectionsExpandedItemViewTomorrowsEarnings
                  }
                </span>
              </li>
            ) : (
              ''
            );
          return (
            <div
              className="content-block"
              className={
                (this.state.wheelDegree === 0 ? 'active content-block' : '') ||
                (this.state.wheelDegree % 360 === 0
                  ? 'active content-block'
                  : '') ||
                (this.state.wheelDegree % -360 === 0
                  ? 'active content-block'
                  : '')
              }
            >
              <h3 className="wheel-stmnt">{projectionSummaryHeader}</h3>
              <h3 className="current-date">
                {ProjectionDateUtils.dateConversion(
                  this.props.projectionSummary.projection_periods[0]
                    .warning_days[0]
                )}
              </h3>
              <h3 className="wheel-stmnt" />
              <ul className="balance-info">
                {currentBalance}
                {tEarnings}
                {commitmentsAmount}
                {essentialSpendAmount}
                {lowBalanceAmount}
              </ul>
              <h3 className="wheel-stmnt2">{message}</h3>
            </div>
          );
        }
      }
    }
  }

  // method to display current balance
  _getCurrentBalanceContent() {
    const footerMessage =
      this.props.content.projectionsExpandedItemViewThisMayDifferFootNote;
    const footerMessage2 = 'This might be different to your available balance';
    let footerMessage4 = '(You can check this in your account screen)';
    let amountArr;
    if (this.props.projectionSummary.projection_periods !== undefined) {
      const cBalance =
        this.props.projectionSummary.projection_periods[0].period.from
          .available_balance.value;
      amountArr = _.split(NumberUtils.appendCurrency('{}', cBalance), '.');
    }
    return (
      <div
        className="content-block"
        className={
          ((this.state.wheelDegree - 288) % 360 === 0
            ? 'active content-block'
            : '') ||
          ((this.state.wheelDegree + 72) % 360 === 0
            ? 'active content-block'
            : '')
        }
      >
        <h3 className="wheel-stmnt">
          {
            this.props.content
              .projectionsExpandedItemViewYourCurrentBalanceHeading
          }
        </h3>
        <h3 className="current-date">
          {amountArr[0]}.<sub>{amountArr[1]}</sub>
        </h3>
        <h3 className="wheel-stmnt2">
          {BrowserUtils.isMobileView() ? footerMessage2 : footerMessage}
        </h3>
        {BrowserUtils.isMobileView() ? (
          <h3 className="wheel-stmnt2">{footerMessage4}</h3>
        ) : (
          ''
        )}
      </div>
    );
  }

  // method to display commitment content
  _getCommitmentContent() {
    let footMessage;
    if (BrowserUtils.isMobileView()) {
      if (this.props.projectionSummary !== undefined) {
        if (
          this.props.projectionSummary.projection_periods[0]
            .projected_transactions.transactions.length > 0
        ) {
          if (
            this.props.projectionSummary.projection_periods[0]
              .projected_transactions.transactions.length === 1
          ) {
            footMessage = 'See this below';
          } else {
            footMessage = 'See what these are below';
          }
        } else if (
          this.props.projectionSummary.projection_periods[0]
            .projected_transactions.transactions.length === 0
        ) {
          footMessage = 'You have no commitments';
        }
      }
    } else {
      if (this.props.projectionSummary !== undefined) {
        if (
          this.props.projectionSummary.projection_periods[0]
            .projected_transactions.transactions.length > 0
        ) {
          footMessage =
            this.props.content
              .projectionsExpandedItemViewYouCanViewTheseFootNote;
        } else if (
          this.props.projectionSummary.projection_periods[0]
            .projected_transactions.transactions.length === 0
        ) {
          footMessage =
            this.props.content
              .projectionsExpandedItemViewYouHaveNoCommitmentsWithin31DaysHeading;
        }
      }
    }
    let count;
    let amount;
    if (this.props.projectionSummary !== undefined) {
      count =
        this.props.projectionSummary.projection_periods[0]
          .projected_transactions.transactions.length;
      if (count > 0) {
        let wheeltext =
          this.props.content
            .projectionsExpandedItemViewYouHaveOneCommitmentHeading;
        if (count > 1) {
          wheeltext = `${this.props.content.projectionsExpandedItemViewYouHaveXCommitmentsPart1Heading} {count} ${this.props.content.projectionsExpandedItemViewYouHaveXCommitmentsPart2Heading}`;
          wheeltext = wheeltext.replace('{count}', count);
        }
        const cBalance =
          this.props.projectionSummary.projection_periods[0]
            .projected_transactions.total_amount.value;
        const amountArr = _.split(
          NumberUtils.appendCurrency('{}', cBalance),
          '.'
        );
        return (
          <div
            className={
              ((this.state.wheelDegree - 216) % 360 === 0
                ? 'active content-block'
                : '') ||
              ((this.state.wheelDegree + 144) % 360 === 0
                ? 'active content-block'
                : '')
            }
          >
            <h3 className="wheel-stmnt">{wheeltext}</h3>
            <h3 className="current-date">
              {amountArr[0]}.<sub>{amountArr[1]}</sub>
            </h3>
            <h3 className="wheel-stmnt2">{footMessage}</h3>
          </div>
        );
      } else if (count === 0) {
        return (
          <div
            className={
              ((this.state.wheelDegree - 216) % 360 === 0
                ? 'active content-block'
                : '') ||
              ((this.state.wheelDegree + 144) % 360 === 0
                ? 'active content-block'
                : '')
            }
          >
            <h3 className="wheel-stmnt">{footMessage}</h3>
          </div>
        );
      }
    }
  }

  // method to display essential Spend content.
  _getEssentialSpendContent() {
    let tagTotalmount;
    let tagsData;
    let content2;
    let thisThese;
    let tagIcon;
    let tagConatainer;
    if (this.props.projectionSummary !== undefined) {
      let tAmount =
        this.props.projectionSummary.projection_periods[0].essential_spend_info
          .total_amount.value;
      if (
        tAmount !== 0 &&
        this.props.projectionSummary.projection_periods[0].essential_spend_info
          .essential_spend.length > 0
      ) {
        const amountArr = _.split(
          NumberUtils.appendCurrency('{}', tAmount),
          '.'
        );
        tagTotalmount = (
          <h3 className="current-date">
            {amountArr[0]}.<sub>{amountArr[1]}</sub>
          </h3>
        );

        tagsData =
          this.props.projectionSummary.projection_periods[0].essential_spend_info.essential_spend.map(
            (essentialSpendings, i) => {
              if (
                this.props.projectionSummary.projection_periods[0]
                  .essential_spend_info.essential_spend.length === 1
              ) {
                if (BrowserUtils.isMobileView()) {
                  tagIcon = (
                    <label className="you-tag">
                      {essentialSpendings.display_name}&nbsp;
                      <span>
                        <strong>
                          {NumberUtils.appendCurrency(
                            '{}',
                            essentialSpendings.amount.value
                          )}
                        </strong>
                      </span>
                    </label>
                  );
                } else {
                  tagIcon = (
                    <label className="you-tag">
                      {essentialSpendings.display_name}&nbsp;
                      <span>
                        {NumberUtils.appendCurrency(
                          '{}',
                          essentialSpendings.amount.value
                        )}{' '}
                      </span>
                    </label>
                  );
                }
                let tag = tagIcon;
                content2 =
                  this.props.content
                    .projectionsExpandedItemViewSingagEssentialSpendWithin31DaysSubHeading;
                thisThese =
                  this.props.content
                    .projectionsExpandedItemViewYouCanChangeThisFootNote;
                return <span className="wheel-tags">{tag}</span>;
              } else {
                let tag = (
                  <label className="you-tag">
                    {essentialSpendings.display_name}&nbsp;&nbsp;
                    <span>
                      {NumberUtils.appendCurrency(
                        '{}',
                        essentialSpendings.amount.value
                      )}{' '}
                    </span>
                  </label>
                );
                content2 = this.props.content.projectionTagsContent;
                thisThese =
                  this.props.content
                    .projectionsExpandedItemViewYouCanChangeTheseFootNote;
                return <span className="wheel-tags">{tag}</span>;
              }
            }
          );
        if (BrowserUtils.isMobileView()) {
          tagConatainer = (
            <div className="wheel-tags-container">{tagsData}</div>
          );
        } else {
          tagConatainer = tagsData;
        }
        return (
          <div
            className={
              ((this.state.wheelDegree - 144) % 360 === 0
                ? 'active content-block'
                : '') ||
              ((this.state.wheelDegree + 216) % 360 === 0
                ? 'active content-block'
                : '')
            }
          >
            <h3 className="wheel-stmnt">
              {this.props.content.projectionsExpandedItemViewYouveTaggedHeading}
            </h3>
            {tagTotalmount}
            <h3 className="wheel-stmnt2">{content2}</h3>
            {tagConatainer}
            <h3 className="wheel-stmnt2">{thisThese}</h3>
          </div>
        );
      } else if (
        tAmount !== 0 &&
        this.props.projectionSummary.projection_periods[0].essential_spend_info
          .essential_spend.length === 0
      ) {
        const amountArr = _.split(
          NumberUtils.appendCurrency('{}', tAmount),
          '.'
        );
        tagTotalmount = (
          <h3 className="current-date">
            {amountArr[0]}.<sub>{amountArr[1]}</sub>
          </h3>
        );

        return (
          <div
            className={
              ((this.state.wheelDegree - 144) % 360 === 0
                ? 'active content-block'
                : '') ||
              ((this.state.wheelDegree + 216) % 360 === 0
                ? 'active content-block'
                : '')
            }
          >
            <h3 className="wheel-stmnt">
              {this.props.content.projectionsExpandedItemViewYouveTaggedHeading}
            </h3>
            {tagTotalmount}
            <h3 className="wheel-stmnt2 stmnt-margin">{content2}</h3>

            <h3 className="wheel-stmnt2">
              {
                this.props.content
                  .projectionsExpandedItemViewYouCanChangeTheseFootNote
              }
            </h3>
          </div>
        );
      } else {
        tagsData = (
          <div>
            {
              this.props.content
                .projectionsExpandedItemViewNoTagsAsEssentialSpendSubHeading
            }
          </div>
        );
        if (BrowserUtils.isMobileView()) {
          tagsData = (
            <div className="wheel-stmnt">
              {
                this.props.content
                  .projectionsExpandedItemViewNoTagsAsEssentialSpendSubHeading
              }
            </div>
          );
        }

        return (
          <div
            className={
              ((this.state.wheelDegree - 144) % 360 === 0
                ? 'active content-block'
                : '') ||
              ((this.state.wheelDegree + 216) % 360 === 0
                ? 'active content-block'
                : '')
            }
          >
            {tagsData}
            <h3 className="wheel-stmnt2">&nbsp;&nbsp;</h3>

            <h3 className="wheel-stmnt2">
              {
                this.props.content
                  .projectionsExpandedItemViewYouCanChangeThisFootNote
              }
            </h3>
          </div>
        );
      }
    }
  }

  // method to display next earning.
  _getNextEarningContent() {
    let amount;
    let earningData;
    let earningDate;
    let whenDate;
    let amountFormat;
    let amountArr;
    let dateOrd;
    let earningHeader1 =
      this.props.content.projectionsExpandedItemViewYourNextEarningHeading;
    let earningFooter1 =
      this.props.content.projectionsExpandedItemViewYouCanReviewThisFootNote;
    let warningDaysFlag = false;
    let tomorrowsFlagForEarnings = false;
    if (this.props.projectionSummary !== undefined) {
      if (this.props.projectionSummary.projection_periods[0] !== undefined) {
        if (
          this.props.projectionSummary.projection_periods[0].warning_days
            .length > 0
        ) {
          warningDaysFlag = true;
        }
        if (
          this.props.projectionSummary.projection_periods[0].earnings.length > 0
        ) {
          earningHeader1 =
            this.props.content
              .projectionsExpandedItemViewTomorrowsEarningHeading;
          earningFooter1 =
            this.props.content
              .projectionsExpandedItemViewSpinTheWheelToSeeTheFutureFootNote;
          tomorrowsFlagForEarnings = true;
        }
      }
    }
    let earningsFirstPeriodAmountArray = [];
    let earningsFirstPeriodTotalAmount = 0;
    let i;
    if (this.props.projectionSummary !== undefined) {
      if (this.props.projectionSummary.projection_periods !== undefined) {
        if (
          this.props.projectionSummary.projection_periods[0].earnings.length > 0
        ) {
          this.props.projectionSummary.projection_periods[0].earnings.map(
            (earningsAmount) => {
              earningsFirstPeriodAmountArray.push(earningsAmount.amount.value);
              earningsFirstPeriodTotalAmount =
                earningsFirstPeriodAmountArray.reduce((a, b) => {
                  return a + b;
                }, 0);
              return earningsFirstPeriodTotalAmount;
            }
          );
        }
      }
    }
    if (this.props.projectionSummary !== undefined) {
      if (this.props.projectionSummary.projection_periods[1] !== undefined) {
        if (
          this.props.projectionSummary.projection_periods[1].earnings.length > 0
        ) {
          amountFormat =
            this.props.projectionSummary.projection_periods[1].earnings[0]
              .amount.value;
          amountArr = _.split(
            NumberUtils.appendCurrency('{}', earningsFirstPeriodTotalAmount),
            '.'
          );
          if (tomorrowsFlagForEarnings === true && warningDaysFlag === true) {
            dateOrd =
              this.props.content
                .projectionsExpandedItemViewTomorrowsEarningRunningLowSubHeading;
            amountArr = _.split(
              NumberUtils.appendCurrency('{}', earningsFirstPeriodTotalAmount),
              '.'
            );
          } else if (
            tomorrowsFlagForEarnings === true &&
            warningDaysFlag === false
          ) {
            dateOrd = ' ';
            amountArr = _.split(
              NumberUtils.appendCurrency('{}', earningsFirstPeriodTotalAmount),
              '.'
            );
          } else if (
            tomorrowsFlagForEarnings === false &&
            warningDaysFlag === false
          ) {
            amountArr = _.split(
              NumberUtils.appendCurrency('{}', amountFormat),
              '.'
            );
            dateOrd =
              this.props.content.projectionsExpandedItemViewProjectedIn +
              ProjectionDateUtils.getDaysCount(
                this.props.projectionSummary.projection_periods[1].earnings[0]
                  .when
              );
          } else if (
            tomorrowsFlagForEarnings === false &&
            warningDaysFlag === true
          ) {
            dateOrd =
              this.props.content.projectionsExpandedItemViewProjectedIn +
              ProjectionDateUtils.getDaysCount(
                this.props.projectionSummary.projection_periods[1].earnings[0]
                  .when
              );
            amountArr = _.split(
              NumberUtils.appendCurrency('{}', amountFormat),
              '.'
            );
          }
          return (
            <div
              className={
                ((this.state.wheelDegree - 72) % 360 === 0
                  ? 'active content-block'
                  : '') ||
                ((this.state.wheelDegree + 288) % 360 === 0
                  ? 'active content-block'
                  : '')
              }
            >
              <h3 className="wheel-stmnt">{earningHeader1}</h3>
              <h3 className="current-date">
                {amountArr[0]}.<sub>{amountArr[1]}</sub>
              </h3>
              <h3 className="wheel-stmnt2">{dateOrd}</h3>
              <h3 className="wheel-stmnt2">{earningFooter1}</h3>
            </div>
          );
        } else {
          earningData = (
            <h3 className="wheel-stmnt">
              {
                this.props.content
                  .projectionsExpandedItemViewNoNextEarningHeading
              }
            </h3>
          );
          earningsHeader = '';
          earningDate = '';
          return (
            <div
              className={
                ((this.state.wheelDegree - 72) % 360 === 0
                  ? 'active content-block'
                  : '') ||
                ((this.state.wheelDegree + 288) % 360 === 0
                  ? 'active content-block'
                  : '')
              }
            >
              <h3 className="wheel-stmnt">{earningsHeader}</h3>
              {earningData}
              {earningDate}
              <h3 className="wheel-stmnt2">
                {
                  this.props.content
                    .projectionsExpandedItemViewYouCanReviewThisFootNote
                }
              </h3>
            </div>
          );
        }
      } else {
        earningData = (
          <h3 className="wheel-stmnt">
            {this.props.content.projectionsExpandedItemViewNoNextEarningHeading}
          </h3>
        );
        earningsHeader = '';
        earningDate = '';
        return (
          <div
            className={
              ((this.state.wheelDegree - 72) % 360 === 0
                ? 'active content-block'
                : '') ||
              ((this.state.wheelDegree + 288) % 360 === 0
                ? 'active content-block'
                : '')
            }
          >
            <h3 className="wheel-stmnt">{earningsHeader}</h3>
            {earningData}
            {earningDate}
            <h3 className="wheel-stmnt2">
              {
                this.props.content
                  .projectionsExpandedItemViewYouCanReviewThisFootNote
              }
            </h3>
          </div>
        );
      }
    }
  }

  // method to handle the done click on the projection wheel screen
  doneClick() {
    // FinancialStoriesActionCreator.handleUpdateFSTileClick();
    InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-DETAILS');
  }

  // method to handle the back to top button for projection screen
  backToTop() {
    this.refs.donBtn.focus();
  }

  // method to return settings page according to screen size
  getSettings() {
    return (
      <SettingsMainPage
        content={this.props.content}
        backToSummary={this.props.backToSummary}
      />
    );
  }

  // method that returns the wheel icons according to screen size
  getWheelToSweep() {
    let iconCss = 'svgicon';
    if (this.props.projectionSummary !== undefined) {
      let warningsCount =
        this.props.projectionSummary.projection_periods[0].warning_days.length;
      if (warningsCount !== 0) {
        iconCss = 'svgicon-alert';
      }
    }
    const circularDeg = {
      WebkitTransform: `rotate(${this.state.wheelDegree}deg)`,
      msTransform: `rotate(${this.state.wheelDegree}deg)`,
      MozTransform: `rotate(${this.state.wheelDegree}deg)`,
      OTransform: `rotate(${this.state.wheelDegree}deg)`,
      transition: `all .4s cubic-bezier(.45, 0, .19, 1.44)`,
    };
    if (BrowserUtils.isMobileView()) {
      circularDeg.height = '120vw';
      return (
        <Swipeable
          onSwipeLeft={this.projectionWheelRightMove}
          onSwipeRight={this.projectionWheelLeftMove}
        >
          <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 955.72 956.04"
            style={circularDeg}
          >
            <title>mobile-wheel</title>
            <g id="Page-1">
              <g id="Artboard">
                <g id="Group-2">
                  <g id="Viewfinder">
                    <g id="Style">
                      <path
                        id="Black"
                        className={iconCss}
                        d="M936.73,462.44c8.85,253.45-189.19,466.08-442.34,474.92S28.84,747.91,20,494.46,209.18,28.37,462.33,19.53,927.88,209,936.73,462.44ZM528.31,476.7a50,50,0,1,0-48.2,51.75A50,50,0,0,0,528.31,476.7Z"
                        transform="translate(-0.69 -0.23)"
                      />
                      <path
                        id="Viewfinder-Main"
                        className="cls-2"
                        d="M860,190.8c158.94,210.92,117,510.6-93.66,669.35S256,976.61,97.1,765.69s-117-510.6,93.66-669.35c157.8-118.91,365.5-125,526.61-32C720.54,66.2,722,79.09,722,79.09s11.93-4.69,15.48-2.4A475,475,0,0,1,793,118.62c3,2.63,1.75,17.26,1.75,17.26s13.81-3,17.08.18A482.5,482.5,0,0,1,860,190.8ZM507.42,476.61a28.68,28.68,0,1,0-27.66,29.66A28.68,28.68,0,0,0,507.42,476.61ZM421,163.11H528.78a8,8,0,0,0,8-8v-108a8,8,0,0,0-8-8H421a8,8,0,0,0-8,8v108A8,8,0,0,0,421,163.11ZM50.33,405.25l102.55,33.32A8,8,0,0,0,163,433.44l33.37-102.72a8,8,0,0,0-5.14-10.08L88.65,287.33a8,8,0,0,0-10.08,5.13L45.19,395.17A8,8,0,0,0,50.33,405.25Zm224.21,457.4,63.38-87.23a8,8,0,0,0-1.76-11.17l-87.38-63.48a8,8,0,0,0-11.17,1.78l-63.38,87.23A8,8,0,0,0,176,800.95l87.38,63.48A8,8,0,0,0,274.54,862.65Zm506.88-71.78L718,703.63a8,8,0,0,0-11.17-1.78L619.5,765.34a8,8,0,0,0-1.76,11.17l63.38,87.23a8,8,0,0,0,11.17,1.78L779.67,802A8,8,0,0,0,781.43,790.87ZM870.54,285,768,318.37a8,8,0,0,0-5.14,10.07l33.37,102.72a8,8,0,0,0,10.08,5.13L908.85,403A8,8,0,0,0,914,392.89L880.62,290.18A8,8,0,0,0,870.54,285Z"
                        transform="translate(-0.69 -0.23)"
                      />
                      <g id="Group">
                        <rect
                          id="Rectangle-37"
                          className="cls-3"
                          x="873.62"
                          y="587.06"
                          width="17.71"
                          height="44.23"
                          transform="translate(29.72 1259.99) rotate(-72)"
                        />
                        <rect
                          id="Rectangle-37-2"
                          data-name="Rectangle-37"
                          className="cls-3"
                          x="468.92"
                          y="880.79"
                          width="17.71"
                          height="44.23"
                        />
                        <rect
                          id="Rectangle-37-3"
                          data-name="Rectangle-37"
                          className="cls-3"
                          x="51.09"
                          y="595.4"
                          width="44.23"
                          height="17.71"
                          transform="matrix(0.95, -0.31, 0.31, 0.95, -183.83, 51.97)"
                        />
                        <rect
                          id="Rectangle-37-4"
                          data-name="Rectangle-37"
                          className="cls-3"
                          x="225.25"
                          y="108.32"
                          width="17.71"
                          height="44.23"
                          transform="matrix(0.81, -0.59, 0.59, 0.81, -32.65, 162.29)"
                        />
                        <rect
                          id="Rectangle-37-5"
                          data-name="Rectangle-37"
                          className="cls-3"
                          x="710.35"
                          y="128.86"
                          width="44.23"
                          height="17.71"
                          transform="translate(189.82 649.12) rotate(-54)"
                        />
                      </g>
                    </g>
                    <g id="icons">
                      <path
                        id="icon-earning"
                        className="cls-2"
                        d="M131,361.21c-.63,1.93-2.34,2.44-3.06,4.65a6.25,6.25,0,0,0-.28,1.89,5.73,5.73,0,0,0-3.66-4.09,5.11,5.11,0,0,0-1.55-.24l1.37-4.21-1.84-.6-1.68,5.18c-2,.66-3.77,1.83-6.26,1-2.73-.89-3.64-3.7-2.78-6.32a5,5,0,0,1,4.23-3.47l-.62-2.76a7.91,7.91,0,0,0-6.09,5.73c-1.36,4.18.43,8.68,4.22,9.92,2.49.81,4.42-.13,6.26-.9L118,370.63l1.84.6,1.61-5a4.75,4.75,0,0,1,2.22.15c2,.67,3.4,2.9,3.71,6.24l2.48-.3a10.4,10.4,0,0,1,0-4.52c.84-2.59,2.57-2.56,3.58-5.67a6.88,6.88,0,0,0-.09-5.18l-2.7.5a4.6,4.6,0,0,1,.3,3.72m13,8.55a24.77,24.77,0,1,1-15.89-31.24A24.78,24.78,0,0,1,144,369.76m-50.48-16.4a28.31,28.31,0,1,0,35.68-18.21,28.32,28.32,0,0,0-35.68,18.21"
                        transform="translate(-0.69 -0.23)"
                      />
                      <path
                        id="icon-essential"
                        className="cls-2"
                        d="M241.28,771.6l32.35,19.33-12.46,17.14-4.3-3.13h0l-4.3-3.12h0l-18-13.1,0,0h0l-7.14-5.19Zm-1.22,29.76-2.71-6.22,8.88,6.45Zm-17.27-18.77,0,.06a1.76,1.76,0,0,0,.3,2.08,1.93,1.93,0,0,0,.53.42l8.19,5.95L236.53,802a3.44,3.44,0,0,0,4,2.93l10.28,0,8.26,6L257,813.8l-1.43-1a1.77,1.77,0,1,0-2.08,2.86l8.6,6.25a1.77,1.77,0,1,0,2.08-2.86l-4.3-3.12,21.84-30.06a1.77,1.77,0,0,0-.39-2.47l-7.16-5.21L257,765.66l-11.46-8.33a1.77,1.77,0,1,0-2.08,2.86l34.39,25-2.17,3-33.18-19.83-.06-.09a1.89,1.89,0,0,0-2.63-.31l-16.54,14.13-.09.09-.07.06-.15.17,0,.05s-.06.1-.09.15Zm53.45-7.3a3.54,3.54,0,1,1,4.95-.78,3.54,3.54,0,0,1-4.95.78Zm7.81,1.3a7.09,7.09,0,1,0-9.89,1.56,7.08,7.08,0,0,0,9.89-1.56Zm-25-13.79A3.54,3.54,0,1,1,264,762a3.54,3.54,0,0,1-4.95.78Zm7.81,1.3a7.09,7.09,0,1,0-9.89,1.56,7.08,7.08,0,0,0,9.89-1.56Z"
                        transform="translate(-0.69 -0.23)"
                      />
                      <path
                        id="icon-commitments"
                        className="cls-2"
                        d="M701.32,760.34,687,770.75l2.08,2.86L703.4,763.2Zm10.4,14.31-22.93,16.66,2.08,2.86,22.93-16.66Zm-43.22.78,34.39-25,25,34.35L720.68,790l-4.16-5.72-20.06,14.58,4.16,5.72-7.16,5.21Zm51.4,19.52-4.3,3.12,1,1.43a1.77,1.77,0,0,1-.39,2.47l-2.87,2.08a1.77,1.77,0,0,1-2.47-.39l-1-1.43-4.3,3.12-4.16-5.73,5.73-4.16,2.87-2.08,5.73-4.16Zm-17.2,12.49,2.08,2.86,4.3-3.12A3.54,3.54,0,0,0,714,808l5.73-4.16a3.54,3.54,0,0,0,.79-4.95l4.3-3.12-2.08-2.86,10-7.29L703.68,745.5l-40.12,29.15,29.12,40.08Zm3.82-39.95-22.93,16.66,2.08,2.86,22.93-16.66Z"
                        transform="translate(-0.69 -0.23)"
                      />
                      <path
                        id="icon-currentbalance"
                        className="cls-2"
                        d="M845,381.53l-3.28-10.11-10.09,3.28,3.28,10.11-8.41,2.73a1.77,1.77,0,0,1-2.23-1.14L811.11,346a1.77,1.77,0,0,1,1.14-2.23l30.29-9.84a1.77,1.77,0,0,1,2.23,1.14l13.14,40.43a1.77,1.77,0,0,1-1.13,2.23ZM836.07,377l2.19,6.74,3.37-1.09-2.19-6.74Zm34.2-9.25a1.77,1.77,0,0,1-1.13,2.23l-8.41,2.73-9.58-29.48Zm-8.45,8.33,10.1-3.28a3.54,3.54,0,0,0,2.27-4.46l-26.6-36.06a3.54,3.54,0,0,0-4.46-2.28l-33.65,10.93a3.54,3.54,0,0,0-2.27,4.46l13.14,40.43,1.09,3.37a3.54,3.54,0,0,0,4.46,2.28l10.1-3.28,10.09-3.28,13.46-4.37a3.54,3.54,0,0,0,2.27-4.46Z"
                        transform="translate(-0.69 -0.23)"
                      />
                      <path
                        id="icon-safe"
                        className="cls-2"
                        d="M465,92.6h35.43a1.77,1.77,0,0,1,1.77,1.77V115.6a1.77,1.77,0,0,1-1.77,1.77H465a1.77,1.77,0,0,1-1.77-1.77V94.37A1.77,1.77,0,0,1,465,92.6m-5.31,0v24.77a3.54,3.54,0,0,0,3.54,3.54h39a3.54,3.54,0,0,0,3.54-3.54V92.6a3.54,3.54,0,0,0-3.54-3.54h-39a3.54,3.54,0,0,0-3.54,3.54m-7.09,17.69h3.54v-3.54h-1.77A1.77,1.77,0,0,1,452.6,105V83.75A1.77,1.77,0,0,1,454.37,82H489.8a1.77,1.77,0,0,1,1.77,1.77v1.77h3.54V82a3.54,3.54,0,0,0-3.54-3.54h-39A3.54,3.54,0,0,0,449.06,82v24.77a3.54,3.54,0,0,0,3.54,3.54m30.11-10.62A5.31,5.31,0,1,1,477.4,105a5.31,5.31,0,0,1,5.31-5.31m0,14.15a8.85,8.85,0,1,0-8.86-8.84,8.85,8.85,0,0,0,8.86,8.84"
                        transform="translate(-0.69 -0.23)"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </Swipeable>
      );
    } else {
      return (
        <Swipeable
          onSwipeLeft={this.projectionWheelLeftMove}
          onSwipeRight={this.projectionWheelRightMove}
        >
          <svg
            version="1.1"
            className="wheel-icon"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 955.7 956.1"
            style={circularDeg}
          >
            <title>Wheel-SVG</title>
            <path
              id="Black"
              className={iconCss}
              d="M19.9,499c-11.7-253.3,184-468.2,437-479.8s467.6,184.3,479.3,437.6c11.7,253.3-184,468.2-437,479.8
                        S31.6,752.3,19.9,499z M428.1,480.1c1.3,27.6,24.7,48.9,52.3,47.6c27.6-1.3,48.9-24.7,47.6-52.3c-1.3-27.6-24.7-48.9-52.2-47.6
	C448.1,429.1,426.8,452.5,428.1,480.1C428.1,480.1,428.1,480.1,428.1,480.1z"
            />
            <path
              id="Viewfinder-Main"
              className="st1"
              d="M99.6,769.7C-61.7,560.6-23.1,260.5,185.8,99.4s509-122.1,670.3,87
                        s122.7,509.3-86.2,670.4c-156.5,120.7-364.1,129.1-526.3,37.8c-3.2-1.8-4.8-14.7-4.8-14.7s-11.9,4.8-15.5,2.6
	c-19.6-12.4-38.3-26.2-55.9-41.3c-3-2.6-1.9-17.2-1.9-17.2s-13.8,3.2-17.1,0C130.8,807.1,114.5,789,99.6,769.7z M429.5,480.9
	c1.2,26.6,23.8,47.1,50.3,45.9c26.6-1.2,47.1-23.8,45.9-50.3c-1.2-26.6-23.8-47.1-50.3-45.9C448.9,431.8,428.3,454.3,429.5,480.9
	L429.5,480.9z M538.9,792.5l-107.8,1.2c-4.4,0-8,3.7-7.9,8.1c0,0,0,0,0,0l1.2,108c0.1,4.4,3.7,8,8.1,7.9l107.9-1.2
	c4.4,0,8-3.7,7.9-8.1c0,0,0,0,0-0.1l-1.2-108C547,796,543.4,792.5,538.9,792.5C538.9,792.5,538.9,792.5,538.9,792.5z M906.8,546.3
	l-102.9-32.2c-4.2-1.3-8.7,1-10,5.2l-32.2,103.1c-1.3,4.2,1,8.7,5.2,10l102.9,32.2c4.2,1.3,8.7-1,10-5.2l32.2-103.1
	C913.4,552.1,911.1,547.6,906.8,546.3z M677.6,91.4l-62.4,87.9c-2.6,3.6-1.7,8.6,1.9,11.2l88.1,62.5c3.6,2.5,8.6,1.7,11.1-1.9
	l62.4-87.9c2.6-3.6,1.7-8.6-1.9-11.2l-88-62.5C685.1,86.9,680.1,87.8,677.6,91.4C677.6,91.4,677.6,91.4,677.6,91.4z M171.5,168.8
	l64.3,86.5c2.6,3.5,7.6,4.3,11.2,1.7l86.7-64.5c3.5-2.6,4.3-7.7,1.6-11.2L271,94.8c-2.6-3.6-7.6-4.3-11.2-1.7c0,0,0,0,0,0
	l-86.7,64.5C169.6,160.3,168.9,165.3,171.5,168.8C171.5,168.8,171.5,168.8,171.5,168.8z M88,675.6l102.2-34.5
	c4.2-1.4,6.4-5.9,5-10.1l-34.5-102.3c-1.4-4.2-6-6.4-10.1-5L48.4,558.1c-4.2,1.4-6.4,5.9-5,10.1l34.5,102.3
	C79.3,674.8,83.8,677,88,675.6C88,675.6,88,675.6,88,675.6L88,675.6z"
            />
            <rect
              id="Rectangle-37"
              x="63.6"
              y="329.5"
              transform="matrix(0.2984 -0.9544 0.9544 0.2984 -284.7509 315.8974)"
              className="st2"
              width="17.7"
              height="44.2"
            />
            <rect
              id="Rectangle-37-2"
              x="464.3"
              y="31.1"
              transform="matrix(0.9999 -1.114713e-02 1.114713e-02 0.9999 -0.5636 5.2781)"
              className="st2"
              width="17.7"
              height="44.2"
            />
            <rect
              id="Rectangle-37-3"
              x="859.8"
              y="339.3"
              transform="matrix(0.9472 -0.3207 0.3207 0.9472 -65.07 301.2886)"
              className="st2"
              width="44.3"
              height="17.7"
            />
            <rect
              id="Rectangle-37-4"
              x="717.3"
              y="801"
              transform="matrix(0.8024 -0.5968 0.5968 0.8024 -347.7335 595.9791)"
              className="st2"
              width="17.7"
              height="44.2"
            />
            <rect
              id="Rectangle-37-5"
              x="205.6"
              y="812.5"
              transform="matrix(0.5787 -0.8155 0.8155 0.5787 -573.9182 531.7592)"
              className="st2"
              width="44.2"
              height="17.7"
            />
            <path
              id="icon-earning"
              className="st1"
              d="M847.8,589.2c-0.6,1.9-2.3,2.4-3,4.7c-0.2,0.6-0.3,1.3-0.3,1.9c-0.5-1.9-1.9-3.4-3.7-4
                        c-0.5-0.2-1-0.2-1.6-0.2l1.3-4.2l-1.9-0.6l-1.6,5.2c-2,0.7-3.7,1.9-6.2,1.1c-2.7-0.9-3.7-3.7-2.9-6.3c0.6-1.9,2.2-3.3,4.2-3.5
	l-0.6-2.7c-2.9,0.6-5.3,2.9-6,5.8c-1.3,4.2,0.5,8.7,4.3,9.9c2.5,0.8,4.4-0.2,6.3-1l-1.1,3.6l1.9,0.6l1.6-5c0.7-0.1,1.5-0.1,2.2,0.1
	c2.1,0.6,3.4,2.9,3.8,6.2l2.5-0.3c-0.4-1.5-0.4-3-0.1-4.5c0.8-2.6,2.5-2.6,3.5-5.7c0.6-1.7,0.6-3.5-0.2-5.2l-2.7,0.5
	C848.1,586.7,848.2,588,847.8,589.2 M860.9,597.6c-4.1,13.1-18,20.3-31.1,16.2s-20.3-18-16.2-31.1c4.1-13,18-20.3,31-16.2
	C857.7,570.7,864.9,584.6,860.9,597.6C860.9,597.6,860.9,597.6,860.9,597.6 M810.2,581.8c-4.6,14.9,3.7,30.8,18.6,35.4
	c14.9,4.6,30.8-3.7,35.4-18.6c4.6-14.9-3.7-30.8-18.6-35.4C830.8,558.5,814.9,566.9,810.2,581.8
	C810.2,581.8,810.2,581.8,810.2,581.8"
            />
            <path
              id="icon-essential"
              className="st1"
              d="M685.8,162l32.6,19l-12.3,17.3l-4.3-3.1l0,0l-4.3-3.1l0,0l-18.2-12.9l0,0l0,0l-7.2-5.1
                        L685.8,162z M684.8,191.8l-2.8-6.2l9,6.4L684.8,191.8z M667.4,173.2L667.4,173.2c-0.4,0.7-0.3,1.6,0.3,2.1c0.2,0.2,0.3,0.3,0.5,0.4
	l8.2,5.9l4.9,10.9c0.3,1.9,2,3.2,3.9,2.9c0.1,0,0.1,0,0.2,0l10.3-0.1l8.3,5.9l-2,2.9l-1.4-1c-0.8-0.6-1.9-0.5-2.5,0.3
	c-0.6,0.8-0.5,1.9,0.3,2.5c0.1,0,0.1,0.1,0.2,0.1l8.7,6.1c0.8,0.6,1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5l0,0l-4.3-3.1l21.5-30.3
	c0.6-0.8,0.4-1.9-0.4-2.5c0,0,0,0,0,0l-7.2-5.1l-17.3-12.3l-11.6-8.2c-0.8-0.6-1.9-0.5-2.5,0.3c-0.6,0.8-0.5,1.9,0.3,2.5
	c0.1,0,0.1,0.1,0.2,0.1l34.7,24.6l-2.1,3l-33.4-19.5l-0.1-0.1c-0.7-0.8-1.8-0.9-2.6-0.3l-16.4,14.3l-0.1,0.1l0,0.1l-0.2,0.2l0,0.1
	l-0.1,0.2L667.4,173.2z M720.7,165.3c-1.6-1.1-2-3.3-0.8-4.9c1.1-1.6,3.3-2,4.9-0.8c1.6,1.1,2,3.3,0.8,4.9c0,0,0,0,0,0
	C724.5,166.1,722.3,166.4,720.7,165.3z M728.6,166.5c2.3-3.2,1.5-7.6-1.7-9.9c-3.2-2.3-7.6-1.5-9.9,1.7c-2.3,3.2-1.5,7.6,1.7,9.9
	c0,0,0,0,0,0C721.9,170.5,726.3,169.7,728.6,166.5C728.6,166.5,728.6,166.5,728.6,166.5z M703.5,153c-1.6-1.1-2-3.3-0.8-4.9
	c1.1-1.6,3.3-2,4.9-0.8c1.6,1.1,2,3.3,0.8,4.9c0,0,0,0,0,0C707.3,153.8,705,154.2,703.5,153z M711.3,154.2c2.3-3.2,1.5-7.6-1.7-9.9
	c-3.2-2.3-7.6-1.5-9.9,1.7s-1.5,7.6,1.7,9.9c0,0,0,0,0,0C704.6,158.2,709,157.4,711.3,154.2C711.3,154.2,711.3,154.2,711.3,154.2z"
            />
            <path
              id="icon-commitments"
              className="st1"
              d="M253.9,153.5L239.7,164l2.1,2.8l14.2-10.6L253.9,153.5z M264.4,167.7l-22.7,16.9l2.1,2.8
                        l22.7-16.9L264.4,167.7z M221.2,168.9l34.1-25.4l25.3,34.1l-7.1,5.3l-4.2-5.7l-19.9,14.8l4.2,5.7l-7.1,5.3L221.2,168.9z
	 M272.8,187.9l-4.3,3.2l1.1,1.4c0.6,0.8,0.4,1.9-0.4,2.5l-2.8,2.1c-0.8,0.6-1.9,0.4-2.5-0.4l-1.1-1.4l-4.3,3.2l-4.2-5.7l5.7-4.2
	l2.8-2.1l5.7-4.2L272.8,187.9z M255.8,200.6l2.1,2.8l4.3-3.2c1.2,1.6,3.4,1.9,5,0.7c0,0,0,0,0,0l5.7-4.2c1.6-1.2,1.9-3.4,0.7-5
	c0,0,0,0,0,0l4.3-3.2l-2.1-2.8l9.9-7.4L256,138.6l-39.8,29.6l29.6,39.8L255.8,200.6z M259.1,160.6l-22.7,16.9l2.1,2.8l22.7-16.9
	L259.1,160.6z"
            />
            <path
              id="icon-currentbalance"
              className="st1"
              d="M125,617.4l-3.4-10.1l-10.1,3.4l3.4,10.1l-8.4,2.8c-0.9,0.3-1.9-0.2-2.2-1.1
                        l-13.6-40.3c-0.3-0.9,0.2-1.9,1.1-2.2l30.2-10.1c0.9-0.3,1.9,0.2,2.2,1.1l13.6,40.3c0.3,0.9-0.2,1.9-1.1,2.2L125,617.4z M116,613
	l2.3,6.7l3.4-1.1l-2.3-6.7L116,613z M150.1,603.3c0.3,0.9-0.2,1.9-1.1,2.2l-8.4,2.8l-9.9-29.4L150.1,603.3z M141.7,611.8l10.1-3.4
	c1.9-0.6,2.8-2.6,2.2-4.5c0,0,0,0,0,0l-27-35.8c-0.6-1.9-2.6-2.8-4.5-2.2L89,577.2c-1.9,0.6-2.8,2.6-2.2,4.5c0,0,0,0,0,0l13.6,40.3
	l1.1,3.4c0.6,1.9,2.6,2.8,4.5,2.2l10.1-3.4l10.1-3.4l13.4-4.6C141.4,615.6,142.4,613.6,141.7,611.8
	C141.8,611.7,141.8,611.7,141.7,611.8L141.7,611.8z"
            />
            <path
              id="icon-safe"
              className="st1"
              d="M470.7,849.7l35.4-0.4c1,0,1.8,0.8,1.8,1.7l0.2,21.2c0,1-0.8,1.8-1.8,1.8c0,0,0,0,0,0l-35.4,0.4
                        c-1,0-1.8-0.8-1.8-1.8c0,0,0,0,0,0l-0.2-21.2C469,850.5,469.8,849.7,470.7,849.7C470.7,849.6,470.7,849.6,470.7,849.7 M465.4,849.7
	l0.3,24.8c0,2,1.6,3.5,3.6,3.5l39-0.4c2,0,3.5-1.6,3.5-3.6c0,0,0,0,0,0l-0.3-24.8c0-2-1.6-3.5-3.6-3.5l-39,0.4
	C467,846.2,465.4,847.8,465.4,849.7C465.4,849.7,465.4,849.7,465.4,849.7 M458.5,867.5l3.5,0l0-3.5l-1.8,0c-1,0-1.8-0.8-1.8-1.8
	c0,0,0,0,0,0l-0.2-21.2c0-1,0.8-1.8,1.8-1.8c0,0,0,0,0,0l35.4-0.4c1,0,1.8,0.8,1.8,1.8c0,0,0,0,0,0l0,1.8l3.5,0l0-3.5
	c0-2-1.6-3.5-3.6-3.5l-39,0.4c-2,0-3.5,1.6-3.5,3.6c0,0,0,0,0,0l0.3,24.8C455,865.9,456.6,867.5,458.5,867.5 M488.6,856.5
	c2.9,0,5.3,2.3,5.4,5.3c0,2.9-2.3,5.3-5.3,5.4c-2.9,0-5.3-2.3-5.4-5.3c0,0,0,0,0,0C483.3,858.9,485.6,856.5,488.6,856.5
	 M488.7,870.6c4.9-0.1,8.8-4.1,8.7-9c-0.1-4.9-4.1-8.8-9-8.7c-4.9,0.1-8.8,4.1-8.7,8.9C479.8,866.8,483.8,870.7,488.7,870.6
	C488.7,870.6,488.7,870.6,488.7,870.6"
            />
          </svg>
        </Swipeable>
      );
    }
  }

  // method to return the actual html component
  getWebView() {
    let wheel, settings;
    let containerClass = '';
    let wheelContainerClass = 'col-xs-6 wheel-holder';
    let wheelScroller = '';
    if (BrowserUtils.isMobileView()) {
      containerClass = 'row landing-content full-height';
      wheelContainerClass = 'col-xs-12 wheel-holder';
    }
    if (BrowserUtils.isMobileView() && !this.props.onLoad) {
      wheelScroller = 'full-height';
    } else if (BrowserUtils.isMobileView() && this.props.onLoad) {
      wheelScroller = 'full-height fixed-container';
    } else if (!BrowserUtils.isMobileView() && !this.props.onLoad) {
      wheelScroller = 'full-height';
    } else if (!BrowserUtils.isMobileView() && this.props.onLoad) {
      wheelScroller = 'full-height';
    } else if (!BrowserUtils.isMobileView() && this.props.onLoad) {
      wheelScroller = 'full-height';
    }
    if (this.props.onLoad) {
      wheel = (
        <div className="scroll-wrapper">
          <div className="row content-wrapper">
            <div className="settings-main-wrapper">
              {BrowserUtils.isMobileView() ? (
                <div className="row no-gutters landing-header">
                  <div className="col-xs-3">
                    <button
                      className="page-back white"
                      ref="donBtn"
                      onClick={this.doneClick}
                    >
                      <span className="icon icon-page-back" />
                      {this.props.content.back}
                    </button>
                  </div>
                  <div className="col-xs-6 text-center">
                    <h5>Projections</h5>
                  </div>
                  <div className="col-xs-3 text-right">
                    <button
                      className="icon icon-settings"
                      onClick={this.props.goToProjectionSettingsPage}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
              {this.props.projectionSummary.projection_periods && (
                <div className={containerClass}>
                  {BrowserUtils.isMobileView() ? (
                    ''
                  ) : (
                    <div className="col-xs-3">
                      <button
                        className="page-back white"
                        ref="donBtn"
                        onClick={this.props.backToAccountPage}
                      >
                        <span className="icon icon-page-back" />
                        {this.props.content.back}
                      </button>
                    </div>
                  )}
                  <div className={wheelContainerClass}>
                    <div className="draggable_wp">
                      {BrowserUtils.isMobileView() ? (
                        <span className="spin-more">Spin for more</span>
                      ) : (
                        <span className="inner-circle" />
                      )}
                      {this.getWheelToSweep()}
                    </div>
                  </div>
                  {BrowserUtils.isMobileView() ? (
                    ''
                  ) : (
                    <div className="col-xs-3">
                      <a
                        className="settings"
                        onClick={this.props.goToProjectionSettingsPage}
                      >
                        <span className="icon icon-settings" />
                      </a>
                    </div>
                  )}

                  <div className="col-xs-12 wheel-msg">
                    <div className="prj-content-wrapper">
                      <span
                        className="slick-prev"
                        onClick={this.projectionWheelLeftClick}
                      >
                        {' '}
                      </span>
                      <span
                        className="slick-next"
                        onClick={this.projectionWheelRightClick}
                      >
                        {' '}
                      </span>
                      {BrowserUtils.isMobileView() ? (
                        <Swipeable
                          ref="2"
                          onSwipeLeft={this.projectionWheelRightMove}
                          onSwipeRight={this.projectionWheelLeftMove}
                        >
                          <div className="sliding-content myitems">
                            {this.props.projectionSummary.projection_periods &&
                              this._getProjectionSummaryContent()}
                            {this.props.projectionSummary.projection_periods &&
                              this._getCurrentBalanceContent()}
                            {this.props.projectionSummary.projection_periods &&
                              this._getCommitmentContent()}
                            {this.props.projectionSummary.projection_periods &&
                              this._getEssentialSpendContent()}
                            {this.props.projectionSummary.projection_periods &&
                              this._getNextEarningContent()}
                          </div>
                        </Swipeable>
                      ) : (
                        <Swipeable
                          ref="2"
                          onSwipeLeft={this.projectionWheelLeftMove}
                          onSwipeRight={this.projectionWheelRightMove}
                        >
                          <div className="sliding-content myitems">
                            {this.props.projectionSummary.projection_periods &&
                              this._getProjectionSummaryContent()}
                            {this.props.projectionSummary.projection_periods &&
                              this._getCurrentBalanceContent()}
                            {this.props.projectionSummary.projection_periods &&
                              this._getCommitmentContent()}
                            {this.props.projectionSummary.projection_periods &&
                              this._getEssentialSpendContent()}
                            {this.props.projectionSummary.projection_periods &&
                              this._getNextEarningContent()}
                          </div>
                        </Swipeable>
                      )}
                    </div>
                  </div>
                  <div className="col-xs-12">
                    {BrowserUtils.isMobileView() ? (
                      <button
                        className="btn-link btn-closer-look"
                        onClick={this.props.changePage}
                      >
                        Take a closer look
                      </button>
                    ) : (
                      <ProjectionDetailsPage
                        projectionSummary={this.props.projectionSummary}
                        content={this.props.content}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
            {BrowserUtils.isMobileView() ? (
              ''
            ) : (
              <p className="back_to_head">
                <a href="javascript:void(0)" onClick={this.backToTop}>
                  <span className="back-to-top-icon">
                    <SvgIcon id="icon-up" width="24px" height="24px" />
                  </span>
                </a>
              </p>
            )}
          </div>
        </div>
      );
    }
    if (!this.props.changeToGrid) {
      return <div className={wheelScroller}>{wheel}</div>;
    } else {
      return (
        <ProjectionGridPanel
          clickBack={this.props.changePage}
          goToProjectionSettingsPage={this.props.goToProjectionSettingsPage}
          projectionSummary={this.props.projectionSummary}
          content={this.props.content}
        />
      );
    }
  }

  render() {
    return this.getWebView();
  }
}

ProjectionScreen.propTypes = {
  content: PropTypes.object,
  projectionSummary: PropTypes.object,
  cancelButtonFlag: PropTypes.bool,
  alertsAmountValue: PropTypes.number,
  notificationFlag: PropTypes.bool,
  earningsAndCommitmentsData: PropTypes.object,
  changeTheValue: PropTypes.func,
  _opt_out_of_projections: PropTypes.func,
  _cancel_button: PropTypes.func,
  onclickLeaveSetup: PropTypes.func,
  optOutFlag: PropTypes.bool,
  cancelFlag: PropTypes.bool,
  onclickCancelForOptOut: PropTypes.func,
  doneProjectionSettings: PropTypes.func,
  changeTheNotificationFlag: PropTypes.func,
  getEarningsId: PropTypes.func,
  modifiedTags: PropTypes.func,
  modifiedUserTag: PropTypes.func,
  onLoad: PropTypes.bool,
  backToAccount: PropTypes.func,
};

export { ProjectionScreen };
